import { render, staticRenderFns } from "./MovementList.vue?vue&type=template&id=fd4cfa9e&scoped=true"
import script from "./MovementList.vue?vue&type=script&lang=js"
export * from "./MovementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4cfa9e",
  null
  
)

export default component.exports